class NavHandler {
    constructor() {
        const navButton = document.querySelector(".nav-button")
        const headerOuter = document.querySelector(".header__outer")
        const nav = document.querySelector(".header__nav")

        // Pages without the header-under partial have no nav button. Bailing
        // out keeps a missing element from throwing and aborting the rest of
        // the DOMContentLoaded init chain.
        if (!navButton) return

        const headerUnderInner = navButton.parentElement.parentElement

        const isOpen = () => nav.classList.contains("resize")
        const syncExpanded = () => navButton.setAttribute("aria-expanded", String(isOpen()))

        const close = () => {
            headerOuter.classList.remove("resize")
            nav.classList.remove("resize")
            headerUnderInner.classList.remove("resize")
            navButton.classList.remove("resize")
            syncExpanded()
        }

        const toggle = () => {
            headerOuter.classList.toggle("resize")
            nav.classList.toggle("resize")
            headerUnderInner.classList.toggle("resize")
            navButton.classList.toggle("resize")
            syncExpanded()
        }

        navButton.addEventListener("click", ev => {
            ev.stopPropagation()
            toggle()
        })

        // Outside click: ignore clicks on the nav itself or the button that
        // opened it, since those have their own handling.
        document.addEventListener("click", ev => {
            if (!isOpen()) return
            if (nav.contains(ev.target) || navButton.contains(ev.target)) return
            close()
        })

        document.addEventListener("keydown", ev => {
            if (ev.key === "Escape" && isOpen()) close()
        })
    }
}

export default NavHandler
